import flatpickr from 'flatpickr'
import './flatpickr.css'

// Vite dynamic imports can not be used to load files from `/node_modules`
import { english as en } from 'flatpickr/dist/l10n/default.js'
import { French as fr } from 'flatpickr/dist/l10n/fr.js'
import { Spanish as es } from 'flatpickr/dist/l10n/es.js'
import { German as de } from 'flatpickr/dist/l10n/de.js'

const locales = { en, es, fr, de }
const locale = document.documentElement.getAttribute('lang')

flatpickr.localize(locales[locale])
flatpickr.setDefaults({
  disableMobile: true,
  monthSelectorType: 'static',
  nextArrow: '',
  position: 'auto left',
  prevArrow: ''
})

export default flatpickr
